import './styles.scss'
import { assetUrl, ID_NAMES, processGender } from "../../env";
import { globalData } from '../..';
import { messagesProcess } from './messagesProcess';
import { DEFAULT_COLORS } from '../../colors';

const chatMessages = () => {

    const { ctaBackgroundColor } = DEFAULT_COLORS
    const { bubbleInsideBodyImage, displayType } = globalData;

    const messagesDiv = document.createElement("div");
    messagesDiv.id = ID_NAMES.CHAT_MESSAGES

    //SCROLLBAR COLOR
    messagesDiv.style.setProperty("--scrollbar-color", ctaBackgroundColor);

    const bubbleBox = document.createElement("div");
    bubbleBox.classList.add('chatheadMessageBubbleBox');
    const bubble = document.createElement("div");
    bubble.id = ID_NAMES.BUBBLE_INSIDE
    bubble.classList.add('chatheadMessageBubble');

    //AVATAR IMG 
    const avatarSrc = displayType === 'random' ? processGender()?.thumbnail : assetUrl(bubbleInsideBodyImage);
    const chatheadAvatar = document.createElement("img");
    chatheadAvatar.src = avatarSrc;
    bubble.append(chatheadAvatar)

    bubbleBox.append(bubble)

    const messageBox = document.createElement("div");
    messageBox.classList.add('chatheadMessageBox');

    //CREATED MESSAGES
    const messages = messagesProcess()
    messages.forEach((html) => messageBox.append(html))

    // message.append(jumpingDots())

    messagesDiv.append(bubbleBox)
    messagesDiv.append(messageBox)

    return messagesDiv

}

export default chatMessages
